import React from "react";
import {
  getHubLogoFontSize,
  getHubLogoInitials,
} from "../../../data/communityHub";

export default function CommunityHubLogo({
  hubName,
  size = 56,
  background = "#15415E",
  className = "",
}: {
  hubName: string;
  size?: number;
  background?: string;
  className?: string;
}) {
  const initials = getHubLogoInitials(hubName);
  const fontSize = getHubLogoFontSize(initials, size);
  const borderRadius = Math.round(size * 0.25);

  return (
    <div
      className={`grid place-items-center shrink-0 text-white font-extrabold overflow-hidden ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius,
        background,
        fontSize,
        lineHeight: 1,
        padding: "0 4px",
        boxSizing: "border-box",
      }}
      aria-hidden
    >
      {initials}
    </div>
  );
}
